module.exports = __webpack_public_path__ + "img/background-register.0aa7be79.jpg";